module.exports = __webpack_public_path__ + "media/img/event/Sponsor-Smart-Robie-15672b4e0634fee2c69383e0bb7e739f.jpg";